// extracted by mini-css-extract-plugin
export default {"html-content":"HtmlRenderer_html-content__BXC5f","article":"HtmlRenderer_article__ScOU+","loading-value":"HtmlRenderer_loading-value__qgsDE"};